<template>
    <div class="third">
        <component
            :is="labelName"
            :ref="labelName"
            :IDlist="IDlist"
            @PersonalPresetService="GOPersonalPresetService"
            @backHome="goBackHome"
        ></component>
    </div>
</template>

<script>
import PresetPersonalServiceIndex from "./components/PresetPersonalServiceIndex";
import PersonalPresetService from "./components/PersonalPresetService";
import { setStore } from "@/utils/store";
export default {
    name: "sensitiveWordIndex",
    data() {
        return {
            labelName: "PresetPersonalServiceIndex",
            IDlist: {}
        };
    },
    components: {
        PresetPersonalServiceIndex,
        PersonalPresetService
    },
    created() {
    },
    methods: {
        // 返回首页
        goBackHome() {
            this.labelName = "PresetPersonalServiceIndex";
        },
        // // 新增/编辑
        GOPersonalPresetService(val) {
            this.labelName = "PersonalPresetService";
            console.log("获取", val);
            this.IDlist = val;
        }
    },
    destroyed() {
        setStore({
            name: 'PresetPersonalService_tab',
            content: '',
            type: 'session'
        })
    },
};
</script>
